export default class ProjectData {
  projectTitle = ''
  hasPro = false
  hasWhIm = false
  mixPoints = 0
  hasPro2 = false
  whEymixL = 0
  hasWatts = false
  hasRpDct = false
  hasWhEymix = false

  replacer = (key: any, value: any) => { // eslint-disable-line
    if (key !== 'rules') return value
  }

  rules = {
    projectTitle: [
      (v: string) => !!(v.trim()) || 'A projektnév megadása kötelező!',
      (v: string) => v.trim().length > 5 || 'Túl rövid projektnév!'
    ]
  }
}
